module.exports = __webpack_public_path__ + "media/images/riders/LEA_DAVISON-cf442cba6348da3c8b5bef1857360ec6.png";